//@flow
import React, {useState} from 'react';
import {
  Button,
  Grid,
  Hidden,
  Typography,
  makeStyles,
  Tabs,
  Tab,
} from '@material-ui/core';
import {Route, Switch} from 'react-router-dom';

import {useInitialProductVisibilitySettings} from '../../product-visibility/utils';
import BannerDesignerForm from './Sections/BannerGroup/BannerForm/BannerDesignerForm';
// import BannerForm from './Sections/MainBanner/BannerForm';
import PopupBannerForm from './Sections/PopupBanner/PopupBannerForm';

import EditAboutUs from './Sections/AboutUsSection/EditAboutUs';
import BackSectionButton from '../../../elements/BackSectionButton/BackSectionButton';
// import VisibilityContainer from './VisibilityContainer/VisibilityContainer';
import HomePagePreview from './HomePagePreview/HomePagePreview';
import {useIsMinimalPlan, useStoreBusinessModel} from '../../store/utils';
import {STATIC_HOME_PAGE_SECTIONS_LIST} from '../utils/home-page-sections/constants';

import {
  useHomePageLayout,
  useInitializeHomePageLayout,
} from '../../page-layout/utils/home-page';
import HomeLayoutSection from './HomeLayoutSection';
import HomeLayoutSectionList from './HomeLayoutSectionList';
import {useGetBannerGroups} from '../utils';
import {useInitializeProductCategoryLayout} from '../utils/product-category-layout';
import {useInitializeBlogPosts} from '../../blog/utils/blog-post';
import {useInitializeBlogAuthors} from '../../blog/utils/blog-author';
import LocationForm from './Sections/Locations/LocationsForm';
import InformationBlockForm from './Sections/InformationBlock/InformationBlockForm';
import {useStoreInformationBlocks} from '../utils/information-block';
/* import StoriesAndTutorials from './Sections/StoriesAndTutorials';
import ProductGallery from './Sections/ProductGallery';
import BlogSection from './Sections/BlogSection';
import InstagramFeed from './Sections/InstagramFeed';
 */
const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    marginTop: '1rem',
    maxWidth: '100%',
    position: 'relative',
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  seeStore: {
    width: 'fit-content',
    borderRadius: 20,
    textTransform: 'none',
    padding: theme.spacing(1, 2),
    background: 'linear-gradient(to right, #FDBD42, #FFDE89)',
    '& p': {
      fontWeight: 600,
      fontSize: 14,
    },
  },
  tab: {
    minWidth: 'unset',
    textTransform: 'none',
    fontWeight: 600,
    fontSize: 14,
  },
}));

export default function HomePage() {
  const classes = useStyles();

  const [openPreview, setOpenPreview] = useState<boolean>(false);
  const storeBusinessModel = useStoreBusinessModel();

  const [sectionActive, setSectionActive] = useState<'DYNAMIC' | 'STATIC'>(
    'DYNAMIC'
  );

  useInitialProductVisibilitySettings();
  useInitializeHomePageLayout();
  useInitializeProductCategoryLayout();
  useGetBannerGroups();
  useInitializeBlogAuthors();
  useInitializeBlogPosts();
  useStoreInformationBlocks();

  const isMinimalPlan = useIsMinimalPlan();

  const homePageLayout = useHomePageLayout();

  const handleChangeTab = (event, newValue: 'DYNAMIC' | 'STATIC') => {
    setSectionActive(newValue);
  };

  return (
    <Switch>
      <Route exact path="/my-store/pages/home-page">
        <HomePagePreview
          open={openPreview}
          handleClose={() => setOpenPreview(false)}
        />
        <main className={classes.root}>
          <Hidden smDown>
            <BackSectionButton to="/my-store/pages" label="Páginas" />
          </Hidden>
          <Tabs
            value={sectionActive}
            onChange={handleChangeTab}
            indicatorColor="primary"
          >
            <Tab
              indicatorColor="primary"
              value="DYNAMIC"
              className={classes.tab}
              label="Secciones Dinámicas"
            />
            <Tab
              indicatorColor="primary"
              className={classes.tab}
              value="STATIC"
              label="Secciones Estáticas"
            />
          </Tabs>
          <Grid container spacing={2}>
            <Hidden smUp>
              <Grid item xs={12}>
                <HomeLayoutSectionList starClosed />
              </Grid>
            </Hidden>
            <Grid item xs={12}>
              <div className={classes.row}>
                {isMinimalPlan && (
                  <Button
                    className={classes.seeStore}
                    onClick={() => setOpenPreview(true)}
                  >
                    <Typography color="primary">
                      Así se vería tu tienda con TiendaDA PRO+
                    </Typography>
                  </Button>
                )}
              </div>
            </Grid>
            <Grid item xs={12} sm={7} md={8}>
              <Grid container spacing={3}>
                {sectionActive === 'STATIC' &&
                  STATIC_HOME_PAGE_SECTIONS_LIST.filter(item =>
                    item.storeBusinessModels.includes(storeBusinessModel)
                  )
                    .filter(({hide}) => !hide)
                    .map(({Component, name}, index) => (
                      <Grid item xs={12} key={`${name}-${index}`}>
                        <Component />
                      </Grid>
                    ))}

                {sectionActive === 'DYNAMIC' &&
                  homePageLayout?.layout.map(section => {
                    const key =
                      section.pageSectionType + section.sectionIdentifier || '';

                    return <HomeLayoutSection key={key} section={section} />;
                  })}
              </Grid>
            </Grid>

            <Hidden xsDown>
              <Grid item xs={12} sm={5} md={4}>
                <HomeLayoutSectionList />
              </Grid>
            </Hidden>
          </Grid>
        </main>
      </Route>
      <Route exact path="/my-store/pages/home-page/about-us">
        <EditAboutUs />
      </Route>

      <Route
        exact
        path="/my-store/pages/home-page/banner/:bannerGroupId/:bannerId"
      >
        <BannerDesignerForm />
      </Route>

      <Route exact path="/my-store/pages/home-page/popup-banner">
        <PopupBannerForm />
      </Route>

      <Route exact path="/my-store/pages/home-page/location/:id">
        <LocationForm />
      </Route>

      <Route exact path="/my-store/pages/home-page/information-block/:id">
        <InformationBlockForm />
      </Route>
    </Switch>
  );
}
